export const validateEmail = (data: string) => {
  if (data && data.match(/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/gi) === null) {
    return 'invalid-email';
  } else {
    return undefined;
  }
};
export const validateURL = (data: string) => {
  if (!data) return undefined;

  const value = data.trim();
  if (!value) return undefined;

  // Reject common local file/path shapes up-front (Windows/macOS/Linux).
  // Examples: C:\path, C:/path, \\server\share, /Users/name/file, file:///C:/path
  if (
    /^[a-zA-Z]:[\\/]/.test(value) ||
    value.startsWith('\\\\') ||
    value.startsWith('/') ||
    value.toLowerCase().startsWith('file:')
  ) {
    return 'invalid-url';
  }

  const withProtocol = /^[a-zA-Z][a-zA-Z0-9+.-]*:\/\//.test(value) ? value : `https://${value}`;

  try {
    const url = new URL(withProtocol);

    // Only internet links.
    if (url.protocol !== 'http:' && url.protocol !== 'https:') return 'invalid-url';
    if (!url.hostname) return 'invalid-url';

    // Require a domain-like hostname (prevents many false-positives like "myfile.txt").
    // If you need to allow intranet hosts like "myhost" later, relax this check.
    if (!url.hostname.includes('.')) return 'invalid-url';

    return undefined;
  } catch {
    return 'invalid-url';
  }
};
export const validateNumber = (data: string) => {
  const value = Number(data);
  if (data && isNaN(value)) {
    return 'invalid-number';
  } else {
    return undefined;
  }
};
export const validateRule = (rule = '') => {
  if (typeof rule === 'string') {
    return rule.split(',').reduce((result: any, key: string) => {
      switch (key) {
        case 'required':
          result['required'] = 'required';
          break;
        case 'requiredMixin':
          result['validate'] = (data: any) => {
            if (typeof data === 'object') {
              if (data.value && data.value.length) return undefined;
            } else if (data) {
              return undefined;
            }
            return 'required';
          };
          break;
        case 'minLength':
          result['minLength'] = {
            value: 2,
            message: 'length-min-error',
          };
          break;
        case 'email':
          result['validate'] = validateEmail;
          break;
        case 'url':
          result['validate'] = validateURL;
          break;
        case 'number':
          result['validate'] = validateNumber;
          break;
      }
      return result;
    }, {});
  } else {
    return undefined;
  }
};
